export const CampaignCreatedIcon = ({ className, size = 27, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.5 13.7513H8L12.5 17.2513V5.41797L8 9.5H1.5V13.7513Z"
            stroke="#4DD15E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.5 18.0833V13.75H6.5V18.0833C6.5 18.9118 5.82843 19.5833 5 19.5833C4.17157 19.5833 3.5 18.9118 3.5 18.0833Z"
            stroke="#4DD15E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M15.5 5.5L21.5 5.5" stroke="#4DD15E" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M18.5 2.5L18.5 8.5" stroke="#4DD15E" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
)

export default CampaignCreatedIcon
